import sellerRegistration from './sellerRegistration/'
import configurationGeneral from './configurationGeneral'

export default {
	...sellerRegistration,
	configurationGeneral
}
